import { render, staticRenderFns } from "./ServiceAdd.vue?vue&type=template&id=0a334bc5&scoped=true"
import script from "./ServiceAdd.vue.js?vue&type=script&lang=js&external"
export * from "./ServiceAdd.vue.js?vue&type=script&lang=js&external"
import style0 from "./ServiceAdd.vue?vue&type=style&index=0&id=0a334bc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a334bc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VSelect,VTextField})
